import type { JSX } from 'react';
import { Route, Routes } from 'react-router-dom';
import { VettingFormPage } from './modules/vetting/VettingFormPage';
import { VettingQueuePage } from './modules/vetting/VettingQueuePage';
import { RegistrarDashboardPage } from './modules/vetting/RegistrarDashboardPage';
import { VettingSignIn } from './modules/auth/VettingSignIn';
import { LogoutPage } from './modules/auth/LogoutPage';
import { LandingPage } from './modules/auth/LandingPage';

export function App(): JSX.Element {
  return (
    <Routes>
      {/* The shared <LoginScreen> (VettingSignIn) owns both the email and code
          steps, so there is no separate /auth/verify. */}
      <Route path="auth/login" element={<VettingSignIn />} />
      <Route path="auth/logout" element={<LogoutPage />} />
      <Route path="form/:parishSlug" element={<VettingFormPage />} />
      <Route path="parish/:parishSlug" element={<VettingQueuePage />} />
      <Route path="registrar" element={<RegistrarDashboardPage />} />
      <Route path="*" element={<LandingPage />} />
    </Routes>
  );
}
